import styled from 'styled-components';

export default styled.div`
  position: relative;
  color: ${({ isActive }) => (isActive ? 'white' : 'inherit')};
`;
